<template>
    <div class="status-bar">
        <div :class="['status', isStatusGreen && 'is-pass']">
            {{ statusText }}
        </div>
        <div class="tip" v-if="isAuditReject">{{ tipText }}</div>
        <div class="reason" v-if="isAuditReject" :title="reason">
            {{ reason }}
        </div>
        <slot></slot>
    </div>
</template>

<script>
import { SHOP_AUDIT_STATUS, INFO_CHANGE_STATUS } from './constants'

const TEXT_TIP = '驳回原因：'

export default {
    name: 'status-bar',
    data() {
        return {
            tipText: TEXT_TIP,
        }
    },
    props: {
        status: {
            required: true,
            type: Number,
        },
        reason: String,
        infoChangeStatus: Number,
    },
    computed: {
        /**
         * @description is audit reject
         * @returns {boolean}
         */
        isAuditReject() {
            return (
                this.status === SHOP_AUDIT_STATUS.OPERATION_REJECT ||
                this.status === SHOP_AUDIT_STATUS.PRE_REJECT ||
                this.status === SHOP_AUDIT_STATUS.CHANGE_REJECT
            )
        },
        /**
         * @description is audit pass
         * @returns {boolean}
         */
        isAuditPass() {
            return (
                this.status === SHOP_AUDIT_STATUS.AUDIT_PASS ||
                this.status === SHOP_AUDIT_STATUS.PRE_PASS
            )
        },
        statusText() {
            return SHOP_AUDIT_STATUS.AUDIT_PASS === this.status
                ? this.infoChangeStatus
                    ? INFO_CHANGE_STATUS.getDescFromValue(this.infoChangeStatus)
                        ? INFO_CHANGE_STATUS.getDescFromValue(
                              this.infoChangeStatus
                          )
                        : SHOP_AUDIT_STATUS.getDescFromValue(this.status)
                    : SHOP_AUDIT_STATUS.getDescFromValue(this.status)
                : SHOP_AUDIT_STATUS.getDescFromValue(this.status)
        },
        isStatusGreen() {
            return (
                this.status === SHOP_AUDIT_STATUS.PRE_PASS ||
                (this.status === SHOP_AUDIT_STATUS.AUDIT_PASS &&
                    !INFO_CHANGE_STATUS.getDescFromValue(
                        this.infoChangeStatus
                    )) ||
                (this.status === SHOP_AUDIT_STATUS.AUDIT_PASS &&
                    this.infoChangeStatus ===
                        INFO_CHANGE_STATUS.MERCHANT_INFO_CHANGE_PASS) ||
                (this.status === SHOP_AUDIT_STATUS.AUDIT_PASS &&
                    this.infoChangeStatus ===
                        INFO_CHANGE_STATUS.SHOP_INFO_CHANGE_PASS)
            )
        },
    },
}
</script>

<style lang="scss" scoped>
.status-bar {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 16px;
    .status {
        line-height: 22px;
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: rgba(244, 67, 54, 1);
        margin-right: 16px;
        &.is-pass {
            color: #3bc500;
        }
    }
    .tip {
        height: 20px;
        line-height: 20px;
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: rgba(244, 67, 54, 1);
    }
    .reason {
        height: 20px;
        line-height: 20px;
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #333;
        width: 600px;
        display: inline-block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .status-btn {
        margin-left: auto;
    }
}
</style>
